<template>
  <div>
    <myHeader></myHeader>

    <div class="webConcept">
      <div class="webHomeTitle1">
        <p class="webHomeContactsIntermediaryFont1">Qui suis-je ?</p>
        <div class="webHomeTitle2">
          <div>
            <img class="webHomePresentationPicture" src="../../assets/Portrait-Sonia.jpg" alt="Photo de la coiffeuse">
          </div>
          <div>
            Je m’appelle Sonia, coiffeuse en salon de coiffure depuis plusieurs années. J’ai décidé de me lancer dans une
            nouvelle aventure : la coiffure à domicile.
            <br>
            <br>
            J’ai obtenu mes diplômes qui me permettent d’avoir une qualification dans ce domaine et me forme régulièrement.
            Je pars du principe que la coiffure, n’est jamais acquise et propose de nouvelles techniques qui évoluent avec
            les années. Mon but est de vous apporter des prestations de qualités avec des produits de qualités. Dites vous,
            que vos
            cheveux sont pour moi, des joyaux dont je dois m’occuper, les soigner ou les embellir sont mes priorités.
            <br>
            <br>
            Amoureuse du métier et de l’échange avec la clientèle, je prends le temps avec vous. Du diagnostique au dernier
            coup de peigne.
            Je viens installer chez vous, mon salon de coiffure…
            Une aventure humaine qui est différente qu’en salon.
            <br>
            <br>
            Je vous dis à bientôt, pour partager ensemble un bout de mon aventure
          </div>
        </div>
      </div>
    </div>

  <myFooter></myFooter>
</div>
</template>

<script>
export default {
  name: 'webConcept',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebConcept.vue